import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import ProfileMediumModel from "../../model/insights/profileMedium.model";
import ProfileMediumInsightModel from "../../model/insights/profileMediumInsight.model";
import Pagination from "../../model/pagination";

@Injectable()
export default class MediaInsightService {
  public constructor(private http: HttpClient) {
  }

  public list(medium: ProfileMediumModel, query?: string, page?: number, limit?: number, sort?: string, direction?: 'asc'|'desc', additionalFilter?: any): Observable<Pagination<ProfileMediumInsightModel>> {
    return this.http.get<Pagination<ProfileMediumInsightModel>>(environment.apiUrl + '/profile-media/' + medium.id + '/insights');
  }

  public show(id: number): Observable<ProfileMediumInsightModel> {
    return this.http.get<ProfileMediumInsightModel>(environment.apiUrl + '/profile-media-insights/' + id);
  }
}
